// extracted by mini-css-extract-plugin
export default {"loader":"DownloadFilePage_loader__dqEpx"};